export const data = {
    name: "Tubing And Packer",
    layout: [],
};
export default data;